module.exports = __webpack_public_path__ + "img/20201216_125317.b58ed200.jpg";